<template>
  <div
    v-check-visible-viewport="onVisibleInViewport"
    v-if="episodesGroup.length"
    class="episode-card-carousel container"
  >
    <h4>Episodes</h4>
    <flickity
      ref="flickity"
      :options="flickityOptions">
      <div
        v-for="(item,index) in episodesGroup"
        :key="index"
        :data-segment-uuid="item[item.length - 1].uuid"
        class="episode-card-container">
        <episode-card
          v-for="(item1,index1) in item"
          :key="`${index1}-${item1.uuid}`"
          :episode-data="item1"
          :has-border="hasBorder(index1)"
          :redirect="redirect"/>
      </div>
    </flickity>
  </div>
</template>
<script>
import * as log from 'loglevel';
import Flickity from 'vue-flickity';
import EpisodeCard from './EpisodeCard';
import CarouselMixin from '../shared/carouselMixin';

export default {
  name: 'EpisodeCardCarousel',
  components: {
    EpisodeCard,
    Flickity,
  },
  mixins: [CarouselMixin],
  props: {
    episodesList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      flickityOptions: {
        prevNextButtons: false,
        freeScroll: true,
        pageDots: false,
        wrapAround: false,
        cellAlign: 'left',
        initialIndex: 0,
        contain: true,
        draggable: '>1',
        groupCells: true,
      },
      episodesGroup: [],
      episodes: [],
      episodeStackCount: 3,
      redirect: false,
    };
  },
  watch: {
    episodesList() {
      if (this.episodesList.length) this.initializeCarousel();
    },
  },
  beforeMount() {
    if (window.innerWidth < this.screenSize.lg && window.innerWidth >= this.screenSize.md) this.episodeStackCount = 4;
  },
  mounted() {
    this.episodes = [...this.episodesList];
    this.episodesList.forEach(() => {
      this.episodesGroup.push(this.episodesList.splice(0, this.episodeStackCount));
    });
    this.initializeCarousel();
  },
  methods: {
    initializeCarousel() {
      this.bucketItems = this.episodes;
      this.bucketData = {
        name: 'Episodes',
        bucket_uuid: null,
        bucket_type: 'episodes',
        media_size: 'episode_three_stack',
      };
      this.bucketData.items = [];
      this.bucketData.position = this.$vnode.key;
      this.bucketData.items_count = this.episodes.length;

      this.dragStart();
      this.carouselSettled();
    },
    dragStart() {
      this.$nextTick().then(() => {
        this.$refs.flickity.on('dragStart', () => {
          this.redirect = false;
        });
      }).catch((err) => { log.warn(err.message); });
    },
    carouselSettled() {
      this.$nextTick().then(() => {
        this.$refs.flickity.on('settle', () => {
          this.redirect = true;
          this.triggerSegmentContentViewedEvent();
        });
      }).catch((err) => { log.warn(err.message); });
    },
    hasBorder(index1) {
      return (index1 + 1) % this.episodeStackCount !== 0;
    },
  },
};
</script>
<style lang="scss" scoped>
.episode-card-carousel {
  h4 {
    margin-bottom: 5px !important;
    font-size: 24px;

    @media (max-width: 768px) {
      margin-top: 56px;
    }
  }
  .episode-card-container {
    width: 33.33%;
    margin-right: 16px;
  }
}
@media (max-width: 1340px) {
  .episode-card-carousel {
    .episode-card-container {
      width: 50%;
      margin-right: 35px;
    }
  }
}
@media (max-width: 768px) {
  .episode-card-carousel {
    .episode-card-container {
      margin-right: 16px;
    }
  }
}
@media (max-width: 576px) {
  .episode-card-carousel {
    .episode-card-container {
      width: 95%;
      margin-right: 16px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// app/src/components/EpisodeCardCarousel.vue